"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInterfaceInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
class UserInterfaceInternalApi extends ApiBase_1.ApiBase {
    prepareAdaptableIconDef(icon) {
        if (icon && 'name' in icon) {
            let customIcon = icon && 'name' in icon
                ? this.adaptable.api.userInterfaceApi.getCustomIconDefinition(icon.name)
                : null;
            if (customIcon) {
                icon = customIcon;
            }
        }
        return icon;
    }
}
exports.UserInterfaceInternalApi = UserInterfaceInternalApi;
